import { React, useState } from 'react'
import { CFormInput, CImage, CButton, CModal, CModalBody, CFormText } from '@coreui/react'
import DummyImg from '../../../assets/campaign-placeholder.png'

const CampaignNameModal = ({ onSave, onCancel }) => {
  const [campaignName, setCampaignName] = useState('')
  const [errorMsg, setErrorMsg] = useState({})
  const limit = 50

  const titleChangeHandler = (newVal) => {
    setErrorMsg((prev) => ({ ...prev, campaignName: '' }))
    setCampaignName(newVal.substring(0, limit))
  }

  const validateInfo = () => {
    let errorObj = {}
    let isValid = true

    if (campaignName.trim().length === 0) {
      errorObj.campaignName = 'Campaign name cannot be empty!'

      isValid = false
    }

    setErrorMsg({ ...errorObj })

    return isValid
  }

  const onSaveHandler = async () => {
    if (!validateInfo()) return
    onSave(campaignName)
  }

  return (
    <CModal size="lg" visible={true} alignment="center" className="custom-form-name-modal border-0">
      <CModalBody
        className="m-auto p-0 rounded-sm"
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-end',
        }}
      >
        <div
          className=" d-flex flex-column justify-content-between align-items-start bg-white"
          style={{
            padding: '2rem 2rem 2rem 2rem',
          }}
        >
          <div style={{ paddingRight: '2rem' }}>
            <h4 className="font-bold text-black">Create your Campaign</h4>
            <p className="text-secondary">
              <small style={{ fontSize: '.75rem' }}>
                Create your Campaign Form which can be used in various places in your platform.
              </small>
            </p>
            <p className="text-secondary">
              <small style={{ fontSize: '.75rem' }}>
                Before going to next step, please select the default view of your Campaign.
              </small>
            </p>
          </div>
          <div className="mt-2 w-100">
            <h6 className="font-bold" style={{ fontSize: '13px' }}>
              Campaign Name
            </h6>
            <CFormInput
              type="text"
              id="floatingInput"
              floatingLabel="Form Name"
              placeholder="ex - Lead Generation Campaign"
              className=" border border-start-0 border-end-0 border-top-0 rounded-0 border-bottom-2 shadow-none p-1 w-100"
              value={campaignName}
              style={{ fontSize: '13px' }}
              onChange={(e) => titleChangeHandler(e.target.value)}
            />
            <div className={`d-flex justify-content-between w-100`}>
              <div className="message-text error-message">
                <p>{errorMsg?.campaignName}</p>
              </div>
              <CFormText
                style={{ color: campaignName.length < limit ? 'black' : 'red', fontSize: '12px' }}
              >
                Characters : {campaignName.length}/{limit}
              </CFormText>
            </div>
          </div>
          <div className="d-flex justify-content-end w-100">
            <CButton
              style={{ color: 'black', border: '1px solid black', fontSize: '.75rem' }}
              className="mr-5 bg-white rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ border: '1px solid black', fontSize: '.75rem' }}
              className="ml-2 bg-black rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={onSaveHandler}
            >
              Next
            </CButton>
          </div>
        </div>
        <CImage src={DummyImg} width="48%" height="100%" fluid align="end" />
      </CModalBody>
    </CModal>
  )
}

export default CampaignNameModal
